// extracted by mini-css-extract-plugin
module.exports = {"cart":"cart-module--cart--3Gb48","title":"cart-module--title--lqPxn","bagsummarycontainer":"cart-module--bagsummarycontainer--1TriU"};